export default "__VITE_ASSET__CehcQSMY__"